import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import GiveBadge from '@wix/da-ds/pkg/Icons/24x24/GiveBadge';
import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { beginDeviationAwardBadgeFlow } from '../../../../../coreBadge/redux/actionCreators';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import FaveControl from '../../../legos/FaveControl';
import CommentControl from '../../../legos/CommentControl';
import s from './BottomInfoBar.scss';
const BottomInfoBar = ({ deviation, className })=>{
    const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
    const { showCommentControl, showFaveControl } = useOverlayContext(deviation);
    const dispatch = useDispatch();
    const handleAwardBadgeClick = useCallback(()=>{
        dispatch(beginDeviationAwardBadgeFlow(deviation));
    }, [
        deviation,
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s['with-badges'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['controls']
    }, showFaveControl && /*#__PURE__*/ React.createElement(FaveControl, {
        deviation: deviation,
        className: s['stat']
    }), showCommentControl && /*#__PURE__*/ React.createElement(CommentControl, {
        deviation: deviation,
        className: s['stat']
    })), !isAuthor && /*#__PURE__*/ React.createElement("div", {
        className: s['actions']
    }, /*#__PURE__*/ React.createElement(BiButton, {
        className: s['award-button'],
        onClick: handleAwardBadgeClick
    }, /*#__PURE__*/ React.createElement(GiveBadge, null))));
};
BottomInfoBar.displayName = 'BottomInfoBar';
export default BottomInfoBar;
